// extracted by mini-css-extract-plugin
module.exports = {"link":"Navigation_link__2cZV7","activ":"Navigation_activ__CkQcs Navigation_link__2cZV7"};